import { useCallback, useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { SaveFilterAreaModalContent } from './components/SaveFilterAreaModalContent'

interface IProps {
  isOpen: boolean
  onCloseDialog: () => void
}

export const SaveFilterAreaModal = ({ isOpen, onCloseDialog }: IProps) => {
  const onClose = useCallback(() => {
    onCloseDialog()
  }, [onCloseDialog])

  const contentProps = useMemo(() => {
    return {
      onClose: onClose,
    }
  }, [onClose])

  return (
    <ModalDialog
      show={isOpen}
      size={'sm'}
      onClose={onClose}
      content={SaveFilterAreaModalContent}
      contentProps={contentProps}
    />
  )
}
